var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticStyle: { height: "120px" } }),
    _c(
      "div",
      {
        staticStyle: {
          background: "#f5f5f5",
          "border-top": "1px solid #c9c9c9",
          "box-shadow": "0 -1px 5px rgb(0 0 0 / 10%)",
          height: "100px",
          width: "100%",
          display: "flex",
          position: "fixed",
          "justify-content": "space-around",
          "flex-direction": "column",
          "align-items": "center",
          bottom: "0",
          "z-index": "99",
        },
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "row",
              "align-items": "center",
              width: "100%",
              "justify-content": "space-evenly",
              padding: "0 50px",
              "box-sizing": "border-box",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "column",
                  width: "50%",
                  height: "60px",
                  "margin-top": "10px",
                  "font-size": "12px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "row",
                      width: "100%",
                      height: "40px",
                      "line-height": "30px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "row",
                          "font-size": "14px",
                          "text-align": "right",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("客服邮箱：" + _vm._s(_vm.configdata.maile))]
                    ),
                    _c("div", {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        width: "5%",
                      },
                    }),
                  ]
                ),
                _c("div", { staticStyle: { "margin-top": "10px" } }, [
                  _vm._v(
                    "Copyright © " +
                      _vm._s(_vm.configdata.companytitle) +
                      " ALL Rights Reserved 版权所有"
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  width: "50%",
                  display: "flex",
                  "flex-direction": "column",
                  height: "60px",
                  "font-size": "14px",
                  "margin-top": "10px",
                },
              },
              [
                _vm._m(0),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-end",
                      height: "30px",
                      "line-height": "30px",
                      width: "100%",
                      "margin-top": "10px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "flex-end",
                          "font-size": "12px",
                        },
                      },
                      [
                        _c("div", { staticStyle: { "margin-right": "10px" } }, [
                          _c(
                            "a",
                            {
                              staticStyle: { color: "#000" },
                              attrs: {
                                target: "_blank",
                                href: "https://beian.miit.gov.cn/#/Integrated/index",
                              },
                            },
                            [
                              _vm._v(
                                " 工信部备案号：" +
                                  _vm._s(_vm.configdata.sitebeian) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "flex-end",
          height: "40px",
          "line-height": "30px",
          width: "100%",
        },
      },
      [
        _c(
          "span",
          {
            staticStyle: {
              "font-family": "Source Han Sans CN",
              "font-weight": "bold",
            },
          },
          [
            _vm._v("服务热线:0531-87903818 "),
            _c(
              "i",
              {
                staticStyle: {
                  "font-style": "normal",
                  "font-weight": "normal",
                  color: "#000",
                  "margin-left": "10px",
                },
              },
              [_vm._v("(工作日 9:00 ~ 18:00) ")]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }